import { makeStyles } from 'tss-react/mui';
import { TimelineDot } from '@mui/lab';
import { ArrowDownward } from '@mui/icons-material';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import React from 'react';

export interface ScrollDownProps {
  onClick?: () => void;
  showPageDown?: boolean;
}

const ScrollDown: React.FC<ScrollDownProps> = ({ onClick, showPageDown }) => {
  const useStyles = makeStyles()({
    root: {
      cursor: 'pointer',
      width: '36px',
      height: '36px',
    },
    dot: {
      backgroundColor: patientAccessTheme.palette.primary[500],
      marginBottom: '0px',
      boxShadow: 'none',
      width: '36px',
      height: '36px',
      marginTop: '6px',
      justifyContent: 'center',
      alignItems: 'center',
    },
  });

  const { classes } = useStyles();
  return (
    <>
      {showPageDown && (
        <div className={classes.root} onClick={onClick}>
          <TimelineDot className={classes.dot}>
            <ArrowDownward
              style={{
                width: '16px',
                height: '16px',
                fill: patientAccessTheme.palette.status.white,
              }}
            />
          </TimelineDot>
        </div>
      )}
    </>
  );
};

export default ScrollDown;
